
import React, { useState } from "react";

const gadgets = [
  {
    title: "Premium Gaming Laptop",
    image: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?q=80&w=1400&auto=format&fit=crop",
    desc: "Powerful gaming laptop with RTX graphics and ultra-fast performance.",
    price: "₹89,999"
  },
  {
    title: "Wireless Headphones",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?q=80&w=1400&auto=format&fit=crop",
    desc: "Crystal clear sound with active noise cancellation technology.",
    price: "₹3,999"
  },
  {
    title: "Smart Watch",
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?q=80&w=1400&auto=format&fit=crop",
    desc: "Track fitness, heart rate and notifications with smart features.",
    price: "₹5,499"
  },
  {
    title: "Professional DSLR Camera",
    image: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?q=80&w=1400&auto=format&fit=crop",
    desc: "Capture every moment in stunning high-resolution quality.",
    price: "₹49,999"
  },
  {
    title: "Bluetooth Speaker",
    image: "https://images.unsplash.com/photo-1545454675-3531b543be5d?q=80&w=1400&auto=format&fit=crop",
    desc: "Portable speaker with immersive bass and long battery backup.",
    price: "₹2,299"
  },
  {
    title: "Flagship Smartphone",
    image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=1400&auto=format&fit=crop",
    desc: "Latest generation smartphone with stunning AMOLED display.",
    price: "₹34,999"
  }
];

const accessories = [
  {
    title: "Mechanical Keyboard",
    image: "https://images.unsplash.com/photo-1511467687858-23d96c32e4ae?q=80&w=1400&auto=format&fit=crop"
  },
  {
    title: "Gaming Mouse",
    image: "https://images.unsplash.com/photo-1527814050087-3793815479db?q=80&w=1400&auto=format&fit=crop"
  },
  {
    title: "VR Headset",
    image: "https://images.unsplash.com/photo-1622979135225-d2ba269cf1ac?q=80&w=1400&auto=format&fit=crop"
  },
  {
    title: "Smart Home Speaker",
    image: "https://images.unsplash.com/photo-1543512214-318c7553f230?q=80&w=1400&auto=format&fit=crop"
  }
];

const reviews = [
  {
    name: "Rahul Sharma",
    review: "Online Gadget Hub has one of the best collections of premium gadgets. Delivery was fast and product quality exceeded expectations."
  },
  {
    name: "Sneha Kapoor",
    review: "The website design is beautiful and shopping experience is smooth. Customer support was extremely helpful."
  },
  {
    name: "Amit Verma",
    review: "I ordered headphones and a smart watch. Both products are amazing and packaging was excellent."
  },
  {
    name: "Priya Mehta",
    review: "Affordable pricing with latest gadgets. Highly recommended for tech lovers."
  }
];

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  return (
    <div>
      <header className="header">
        <div className="logo">Online Gadget Hub</div>

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>

        <nav className={menuOpen ? "nav active" : "nav"}>
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#products">Products</a>
          <a href="#accessories">Accessories</a>
          <a href="#reviews">Reviews</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>

      <section className="hero" id="home">
        <div className="hero-content">
          <h1>Experience The Future Of Technology</h1>
          <p>
            Discover premium gadgets, gaming devices, smart accessories, laptops,
            smartphones and futuristic electronics at unbeatable prices.
          </p>

          <div className="hero-buttons">
            <a href="#products"> <button  >Explore Gadgets</button> </a>
            <a href="#products"><button className="secondary-btn" >Latest Offers</button> </a>
          </div>
        </div>
      </section>

      <section className="about" id="about">
        <div className="section-overlay">
          <h2>About Online Gadget Hub</h2>

          <p>
            Online Gadget Hub is a modern electronics and gadget marketplace created for
            technology enthusiasts. We provide premium quality gadgets, gaming devices,
            smart home products, laptops, headphones, cameras and accessories from trusted brands.
          </p>

          <p>
            Our mission is to make advanced technology accessible to everyone through
            affordable pricing, fast delivery, secure shopping and exceptional customer support.
          </p>

          <div className="features-grid">
            <div className="feature-card">
              <h3>1000+ Products</h3>
              <p>Explore a huge collection of trending gadgets and accessories.</p>
            </div>

            <div className="feature-card">
              <h3>Fast Delivery</h3>
              <p>Quick and secure delivery services across India.</p>
            </div>

            <div className="feature-card">
              <h3>Trusted Quality</h3>
              <p>All products are quality checked and verified.</p>
            </div>

            <div className="feature-card">
              <h3>24/7 Support</h3>
              <p>Dedicated customer assistance whenever you need help.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="products-section" id="products">
        <h2>Trending Gadgets</h2>

        <div className="products-grid">
          {gadgets.map((item, index) => (
            <div className="product-card" key={index}>
              <img src={item.image} alt={item.title} />

              <div className="card-content">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
                <h4>{item.price}</h4>

                <button onClick={() => setShowPopup(true)}>
                  Order Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="accessories-section" id="accessories">
        <div className="section-overlay">
          <h2>Latest Accessories Collection</h2>

          <p className="section-desc">
            Enhance your setup with stylish and powerful accessories built for productivity,
            entertainment and gaming.
          </p>

          <div className="accessories-grid">
            {accessories.map((item, index) => (
              <div className="accessory-card" key={index}>
                <img src={item.image} alt={item.title} />
                <div className="accessory-overlay">
                  <h3>{item.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="reviews-section" id="reviews">
        <h2>What Our Customers Say</h2>

        <div className="reviews-grid">
          {reviews.map((item, index) => (
            <div className="review-card" key={index}>
              <p>"{item.review}"</p>
              <h4>- {item.name}</h4>
            </div>
          ))}
        </div>
      </section>

      <section className="contact-section" id="contact">
        <div className="section-overlay">
          <h2>Contact Us</h2>

          <p className="section-desc">
            Have questions about our products or services? Contact our team anytime.
          </p>

          <div className="contact-wrapper">
            <form className="contact-form">
              <input type="text" placeholder="Your Name" />
              <input type="email" placeholder="Your Email" />
              <input type="text" placeholder="Phone Number" />
              <textarea placeholder="Write your message"></textarea>
              <button type="submit">Submit</button>
            </form>

            <div className="contact-info">
              <h3>Business Details</h3>

              <p><strong> Name:</strong> Satyam Kumar</p>
              <p><strong>Email:</strong> admin@onlinegadgethub.store</p>
              <p><strong>Phone:</strong> +91 6396094526</p>
              <p><strong>Address:</strong> GF, C/O SOHIT KUMAR,: BIJNOR CODE NO 101 R, INNER RING ROAD, Shahbazpur Khana, Bijnor, Uttar Pradesh, 246701</p>

              <div className="timing">
                <h3>Opening Hours</h3>
                <p>Monday - Sunday</p>
                <p>9:00 AM - 10:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>© 2026 Online Gadget Hub. All Rights Reserved.</p>
      </footer>

      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h3>For Order Please Call</h3>
            <p>+91 6396094526</p>
            <button onClick={() => setShowPopup(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}
